import { IUserRoles } from 'contexts/user'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

export const isPermitted = (userRole: IUserRoles, allowedRole: IUserRoles) => {
  switch (userRole) {
    case 'VIEWER':
      if (allowedRole == 'VIEWER') return true
      break
    case 'TESTER':
      if (['VIEWER', 'TESTER'].indexOf(allowedRole) >= 0) return true
      break
    case 'LIVE SERVICE':
      if (['VIEWER', 'TESTER', 'LIVE SERVICE'].indexOf(allowedRole) >= 0) return true
      break
    case 'MASTER':
      if (allowedRole !== 'OWNER') return true
      break
    case 'OWNER':
      return true
  }
  return false
}

export const isOverlappingDateRange = (start_time1: any, end_time1: any, start_time2: any, end_time2: any) => {
  if (dayjs(start_time1).isSameOrAfter(dayjs(end_time2)) || dayjs(end_time1).isSameOrBefore(dayjs(start_time2))) {
    return false
  } else { return true }
}


export const checkValidRewardValue = (rewardItem: any) => {
  let id = rewardItem.item_id
  let value = rewardItem.item_value

  return (id && value)
}